exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-action{margin-bottom:4px}.crs-title{border-bottom:1px dashed #000;padding-bottom:10px}.small-box h3{font-size:1.7rem;font-weight:600;margin:10px 0;padding:0;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75a783c2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homePage.vue
// module id = 89
// module chunks = 0